import { useReducer } from 'react'
import { useApplyLoggerDispatch } from 'utilities/debug/logUtil'
import { CustomerFacingActionType } from './CustomerFacingActionType'
import { CFDClientMessageType, CustomerFacingDisplayState } from './Interface'
import {
    HWAGENT_STORE,
    CLIENT_STORE,
} from 'views/CustomerFacingDisplay/utils/localStorageKey'

const initstate: CustomerFacingDisplayState = {
    payload: undefined,
    state: CFDClientMessageType.Order,
    clientID: undefined,
    hwAgentUrl: undefined,
    isConnected: false,
    isManualConnect: false,
    isLoadedLocalSetting: false,
}
function reducer(
    state: CustomerFacingDisplayState = initstate,
    action: CustomerFacingActionType,
): CustomerFacingDisplayState {
    const { type } = action
    switch (type) {
        case 'CFD_LOADED_SETTING': {
            return {
                ...state,
                isLoadedLocalSetting: true,
                clientID: action.payload.clientID,
                hwAgentUrl: action.payload.hwAgentUrl,
            }
        }
        case 'CFD_SET_HW_URI': {
            if (action.payload.url) {
                if (!action.payload.isAuto)
                    localStorage.setItem(HWAGENT_STORE, action.payload.url)
            } else localStorage.removeItem(HWAGENT_STORE)
            return {
                ...state,
                hwAgentUrl: action.payload.url,
            }
        }
        case 'CFD_SET_CLIENT': {
            const isManualConnect = !action.payload.clientID
            if (action.payload.clientID)
                localStorage.setItem(CLIENT_STORE, action.payload.clientID)
            else {
                localStorage.removeItem(CLIENT_STORE)
            }

            return {
                ...state,
                clientID: action.payload.clientID,
                isManualConnect,
            }
        }
        case 'CFD_CONNTECTED_TO_POS': {
            return {
                ...state,
                isConnected: true,
            }
        }
        case 'CFD_DISCONNTECTED_TO_POS': {
            return {
                ...state,
                isConnected: false,
            }
        }
        case 'CFD_SET_PAYLOAD': {
            return {
                ...state,
                payload: action.payload,
                state: action.payload.type,
            }
        }
        default:
            return state
    }
}
const useCustomerFacingDisplayReducer = () => {
    const [saleSelectObject, dispatch] = useReducer(reducer, initstate)

    const dispatchFunc = useApplyLoggerDispatch(
        'CustomerFacingDisplayAction',
        dispatch,
        saleSelectObject,
    )

    return { state: saleSelectObject, dispatch: dispatchFunc }
}
export default useCustomerFacingDisplayReducer
